import { Speaker } from '@/models/speaker';
import { Session } from '@/models/session';
let SpeakerVar: Speaker | any;
let SessionVar: Session | any;

// VALIDATORS
export function validateSpeaker(speaker: Speaker): boolean {
  return speaker instanceof SpeakerVar;
}
export function validateSession(session: Session): boolean {
  return session instanceof SessionVar;
}

export function setForm(payload: any) {
  console.log(payload);

  const data = new FormData();
  for (const key in payload) {
    // if (payload.hasOwnProperty(key)) {
    // if (payload.id) return

    const value = payload[key];

    if (value != null) {
      // if (payload[key] instanceof File) {
      //   data.append(key, value);
      // }
      // else {
      console.log(key, value);

      data.append(key, value);
      // payload[key] = null;
      // }
    }
  }
  console.log(data);

  // }
  // }
  return data;
}
